import {
  Briefcase,
  Building2,
  Calendar,
  CircleDot,
  FileText,
  FolderKanban,
  Inbox,
  LayoutTemplate,
  type LucideIcon,
  Mail,
  MessageSquare,
  Settings,
  Square,
  SquareCheck,
  StickyNote,
  Tag,
  User,
} from 'lucide-react'

const KIND_ICONS: Record<string, LucideIcon> = {
  project: FolderKanban,
  projects: FolderKanban,
  user: User,
  users: User,
  member: User,
  members: User,
  contact: User,
  contacts: User,
  team: User,
  teams: User,
  deal: Briefcase,
  deals: Briefcase,
  rfp: Briefcase,
  rfps: Briefcase,
  template: LayoutTemplate,
  templates: LayoutTemplate,
  conversation: MessageSquare,
  conversations: MessageSquare,
  chat: MessageSquare,
  chats: MessageSquare,
  message: MessageSquare,
  messages: MessageSquare,
  email: Mail,
  emails: Mail,
  note: StickyNote,
  notes: StickyNote,
  doc: FileText,
  docs: FileText,
  document: FileText,
  documents: FileText,
  file: FileText,
  files: FileText,
  page: FileText,
  pages: FileText,
  request: Inbox,
  requests: Inbox,
  ticket: Inbox,
  tickets: Inbox,
  company: Building2,
  companies: Building2,
  organization: Building2,
  organizations: Building2,
  event: Calendar,
  events: Calendar,
  appointment: Calendar,
  appointments: Calendar,
  tag: Tag,
  tags: Tag,
  setting: Settings,
  settings: Settings,
}

export function iconForKind(kind: string | undefined): LucideIcon {
  if (!kind) {
    return CircleDot
  }
  return KIND_ICONS[kind.toLowerCase()] ?? CircleDot
}

function isTaskKind(kind: string | undefined): boolean {
  if (!kind) {
    return false
  }
  const k = kind.toLowerCase()
  return k === 'task' || k === 'tasks' || k === 'subtask' || k === 'subtasks'
}

export function KindIcon({
  kind,
  completed = false,
  size = 14,
}: {
  kind: string | undefined
  completed?: boolean
  size?: number
}) {
  if (isTaskKind(kind)) {
    return completed ? <SquareCheck size={size} aria-hidden /> : <Square size={size} aria-hidden />
  }
  const Icon = iconForKind(kind)
  return <Icon size={size} aria-hidden />
}
